import {doGet, doPost} from '@/util/request'
import request from '@/util/request2';

// 保存部门
export async function saveUserApi(params) {
  return await doPost('/api/auth/sysUser/save', params);
}

//分页查询
export async function listUserApi(params) {
  return request({
    url: '/api/auth/sysUser/pager',
    method: 'post',
    data: params
  });
}

//查询部门
export async function getUserById(id) {
  return await doGet('/api/auth/sysUser/getById?id=' + id);
}

//删除用户
export async function delUserApi(ids) {
  return await doGet('/api/auth/sysUser/delete?ids=' + ids);
}

//更新状态
export function updateAvailableApi(params) {
  return doGet('/api/auth/sysUser/updateAvailable?id=' + params.id + "&available=" + params.available);
}

//登录
export async function loginApi(params) {
  return await doPost('/api/sys/login', params);
}

//查询详情
export async function findByIdApi(id) {
  return doGet('/api/auth/sysUser/findById?id=' + id);
}

//修改密码
export async function resetPwdApi(pwd) {
  return doGet('/api/auth/sysUser/resetPwd?pwd=' + pwd);
}

//退出登录
export async function logoutApi() {
  return doPost('/api/auth/sys/logout');
}